import { ProcessDeUtil } from '../../domain/process-de-util';

export class ApprovalPivot {
    constructor() {
        this.id = ProcessDeUtil.GenerateElementId();
        this.type = 'REMIND';
    }
    id: string;
    type: string;
    condition: string;
    title: string;
    description: string;
}
